import {
  configureStore,
} from "@reduxjs/toolkit";
import apiSlice from "../features/api/apiSlice";
import taskSliceReducer from "../features/task/taskSlice";
import projectsSliceReducer from "../features/projects/projectsSlice";
import teamSliceReducer from "../features/team/teamSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    projects: projectsSliceReducer,
    team: teamSliceReducer,
    task: taskSliceReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
